import React, { useState } from 'react';
import { usePathname } from 'next/navigation';
import * as S from './SearchPanel.styles';
import { SearchPanelForm } from './components/SearchPanelForm';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { ROUTES } from '@/constants/routes';
import { Badge } from '@/components/UI/Badge/Badge';
import { FiltersDrawer } from '@/components/FiltersDrawer/FiltersDrawer';

interface SearchPanelProps {
  hasFilters?: boolean;
}

// TODO: change to true when business logic on BE will be ready
export const SearchPanel = ({ hasFilters = false }: SearchPanelProps) => {
  const pathname = usePathname();
  const [filterCount, setFilterCount] = useState(0);
  const [isFiltersOpen, toggleFilters] = useToggleOpenState();

  return (
    <S.SearchPanelBox
      data-testid={CommonTestIds.searchPanel.box}
      $isHomePage={pathname === ROUTES.home}
    >
      <SearchPanelForm />
      {hasFilters && (
        <>
          <Badge value={filterCount}>
            <S.SearchPanelFiltersBtn
              onClick={toggleFilters}
              data-testid="filters-button"
            >
              <S.SearchPanelFiltersBtnIcon />
            </S.SearchPanelFiltersBtn>
          </Badge>
          <FiltersDrawer
            isOpen={isFiltersOpen}
            close={toggleFilters}
            setFilterCount={setFilterCount}
          />
        </>
      )}
    </S.SearchPanelBox>
  );
};
